// 公共过滤器
export function filterEmpty(val) {
  var _result = '-';
  if (!val) {
    return _result;
  }
  _result = val;
  return _result;
}
export function filterYesOrNo(value) {
  return value ? '是' : '否';
}
export function filterShowOrHide(value) {
  return value ? '显示' : '不显示';
}
export function filterShowOrHideForFormConfig(value) {
  return value === '‘0’' ? '显示' : '不显示';
}
export function filterYesOrNoIs(value) {
  return value ? '否' : '是';
}

/**
 * @description 支付状态
 */
export function paidFilter(status) {
  var statusMap = {
    0: '未支付',
    1: '已支付'
  };
  return statusMap[status];
}
/**
 * @description 订单支付类型
 */
export function payTypeFilter(status) {
  var statusMap = {
    '0': '余额',
    '1': '微信',
    '2': '微信',
    '3': '微信',
    '4': '支付宝',
    '5': '支付宝',
    '7': '线下支付'
  };
  return statusMap[status];
}

/**
 * @description 订单状态
 */
export function orderStatusFilter(status) {
  var statusMap = {
    '0': '待发货',
    '1': '待收货',
    '2': '待评价',
    '3': '已完成',
    '-1': '已退款',
    '9': '未成团',
    '10': '待付尾款',
    '11': '尾款过期未付',
    '12': '待赠送'
  };
  return statusMap[status];
}

// 预约商品的订单状态 上门订单
export function reservationOrderStatusFilter(status) {
  var statusMap = {
    '-1': '已退款',
    '0': '派单中',
    '1': '待服务',
    '2': '待评价',
    '3': '已完成',
    '20': '服务中'
  };
  return statusMap[status];
}
// 预约商品的订单状态 到店订单enable_assigned =0无需派单
export function reservationOrderStatusFilter1(obj) {
  // 无需派单
  var statusMap = {};
  if (obj.enable_assigned === 0) {
    statusMap = {
      '-1': '已退款',
      '0': '待核销',
      '2': '待评价',
      '3': '已完成'
    };
  } else {
    statusMap = {
      '-1': '已退款',
      '0': '派单中',
      '1': '待核销',
      '2': '待评价',
      '3': '已完成'
    };
  }
  return statusMap[obj.status];
}

/**
 * @description 订单活动状态
 */
export function activityOrderStatus(status) {
  var statusMap = {
    '-1': '未完成',
    '10': '已完成',
    '0': '进行中'
  };
  return statusMap[status];
}
export function cancelOrderStatusFilter(status) {
  var statusMap = {
    '0': '待核销',
    '2': '待评价',
    '3': '已完成',
    '-1': '已退款',
    '10': '待付尾款',
    '11': '尾款过期未付',
    '12': '待赠送'
  };
  return statusMap[status];
}
/**
 *
 * 支付方式
 */

export function orderPayType(type) {
  var typeMap = {
    '0': '余额支付',
    '1': '微信支付',
    '2': '小程序',
    '3': '微信支付',
    '4': '支付宝',
    '5': '支付宝扫码',
    '6': '微信扫码',
    '7': '线下支付',
    '8': '扫码枪支付'
  };
  return typeMap[type];
}
/**
 * @description 自提订单状态
 */
export function takeOrderStatusFilter(status) {
  var statusMap = {
    '0': '待核销',
    '1': '待提货',
    '2': '待评价',
    '3': '已完成',
    '-1': '已退款',
    '9': '未成团',
    '10': '待付尾款',
    '11': '尾款过期未付'
  };
  return statusMap[status];
}

/**
 * @description 退款单状态
 */
export function orderRefundFilter(status) {
  var statusMap = {
    '0': '待审核',
    '-1': '拒绝退款',
    '-2': '已取消',
    '1': '待退货',
    '2': '待收货',
    '3': '已退款',
    '4': '维权中',
    '5': '审核中'
  };
  return statusMap[status] || '-';
}

/**
 * @description 提现状态
 */
export function accountStatusFilter(status) {
  var statusMap = {
    0: '未转账',
    1: '已转账'
  };
  return statusMap[status];
}

/**
 * @description 订单对账类型
 */
export function reconciliationFilter(value) {
  return value > 0 ? '已对账' : '未对账';
}

/**
 * @description 对账状态
 */
export function reconciliationStatusFilter(status) {
  var statusMap = {
    0: '未确认',
    1: '已拒绝',
    2: '已确认'
  };
  return statusMap[status];
}
/**
 * @description 商品状态
 */
export function productStatusFilter(status) {
  // 处理 null、undefined 或空值
  if (status === null || status === undefined || status === '') {
    return '下架';
  }
  // 转换为字符串，确保能正确匹配
  var statusStr = String(status);
  var statusMap = {
    '0': '下架',
    '1': '上架显示',
    '-1': '平台关闭'
  };
  return statusMap[statusStr] || '下架';
}
/**
 * @description 优惠券类型
 */
export function couponTypeFilter(status) {
  var statusMap = {
    0: '店铺券',
    1: '商品券'
  };
  return statusMap[status];
}
/**
 * @description 优惠券使用类型
 */
export function couponUseTypeFilter(status) {
  var statusMap = {
    0: '店铺券',
    1: '商品券',
    10: '平台通用券',
    11: '平台品类券',
    12: '平台跨店券'
  };
  return statusMap[status];
}
/**
 * @description 是否关闭点赞、评论
 */
export function filterClose(value) {
  return value ? '✔' : '✖';
}
/**
 * @description 导出订单状态
 */
export function exportOrderStatusFilter(status) {
  var statusMap = {
    '0': '正在导出，请稍后再来',
    '1': '完成',
    '2': '失败'
  };
  return statusMap[status];
}
/**
 * @description 资金明细订单类型
 */
export function transactionTypeFilter(type) {
  var typeMap = {
    mer_accoubts: '财务对账',
    order: '订单支付',
    presell: '预售订单（尾款）',
    brokerage_one: '一级分佣',
    brokerage_two: '二级分佣',
    order_charge: '技术手续费',
    order_pay_channel_charge: '支付通道费',
    order_true: '商户入账',
    refund_order: '退款订单',
    refund_charge: '返还手续费',
    refund_pay_channel_charge: '返还支付通道费',
    refund_true: '商户返还入账',
    presell_charge: '预售订单（手续费）',
    presell_true: '商户入账',
    refund_brokerage_one: '返还一级分佣',
    refund_brokerage_two: '返还二级分佣',
    mer_presell: '预售订单（总额）',
    order_presell: '预售订单（定金）',
    refund_platform_coupon: '退回优惠券补贴',
    order_platform_coupon: '优惠券补贴',
    order_svip_coupon: '付费会员卷',
    refund_svip_coupon: '退回付费会员卷',
    order_contribution: '贡献值扣款',
    refund_order_contribution: '贡献值退回',
    order_asset_token: '彩章成本',
    points_order_true: '积分订单入账',
    svip: '支付会员费'
  };
  return typeMap[type] || type || '-';
}
/**
 * @description 发货记录状态
 */
export function deliveryStatusFilter(status) {
  var statusMap = {
    '0': '处理中',
    '1': '成功',
    '10': '部分完成',
    '-1': '失败'
  };
  return statusMap[status];
}
/**
 * @description 主体类型
 */
export function organizationType(type) {
  var typeMap = {
    2401: '小微商户',
    2500: '个人卖家',
    4: '个体工商户',
    2: '企业',
    3: '党政、机关及事业单位',
    1708: '其他组织'
  };
  return typeMap[type];
}
/**
 * @description 证件类型
 */
export function id_docType(type) {
  var typeMap = {
    1: '中国大陆居民-身份证',
    2: '其他国家或地区居民-护照',
    3: '中国香港居民–来往内地通行证',
    4: '中国澳门居民–来往内地通行证',
    5: '中国台湾居民–来往大陆通行证'
  };
  return typeMap[type];
}
/**
 * @description 证件类型
 */
export function deliveryType(type) {
  var typeMap = {
    1: '发货',
    2: '送货',
    3: '无需物流',
    4: '电子面单'
  };
  return typeMap[type];
}
/**
 * @description 跑腿配送状态
 */
export function runErrandStatus(status) {
  var statusMap = {
    '-1': '已取消',
    '0': '待接单',
    '2': '待取货',
    '3': '配送中',
    '4': '已完成',
    '9': '物品返回中',
    '10': '物品返回完成',
    '100': '骑士到店'
  };
  return statusMap[status];
}
/**
 * @description 发送方式
 */
export function sendWay(type) {
  var typesMap = {
    null: '-',
    '1': '快递',
    '2': '配送',
    '3': '虚拟发货',
    '4': '快递',
    '5': '配送',
    '6': '自动发货'
  };
  return typesMap[type];
}

/**
 * @description 表单类型
 */
export function formTypeFilter(type) {
  var typesMap = {
    citys: '城市',
    dates: '日期',
    uploadPicture: '图片',
    texts: '文本框',
    times: '时间',
    timeranges: '时间范围',
    radios: '单选框',
    selects: '下拉框',
    checkboxs: '多选框',
    dateranges: '日期范围'
  };
  return typesMap[type];
}